interface HandleAnchorClickProps {
  url: string;
  id?: string;
  onClose?: () => void;
}

export const handleAnchorClick = ({
  url,
  id,
  onClose,
}: HandleAnchorClickProps) => {
  if (url.includes("#")) {
    if (id) {
      const validClass = id.replace(/=/gi, "");
      const overlay = document.body.querySelector(
        `.enhanced-menu-overlay.${validClass}`
      );
      if (overlay) {
        overlay.remove();
      }
    }
    onClose?.();
  }
};
